import './Products.scss';
import Component from './Products.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
